import React from 'react';
import { connect } from 'react-redux';
import agent from '../../agent';
import { Link } from 'react-router-dom';
import {
  HOME_PAGE_LOADED,
  HOME_PAGE_UNLOADED,
} from '../../constants/actionTypes';

const Promise = global.Promise;

const mapStateToProps = state => ({
  ...state.home,
  appName: state.common.appName,
  token: state.common.token,
  currentUser: state.common.currentUser,
  tables: state.tables || []
});

const mapDispatchToProps = dispatch => ({
  onLoad: (tab, payload) =>
    dispatch({ type: HOME_PAGE_LOADED, tab, payload }),
  onUnload: () =>
    dispatch({ type: HOME_PAGE_UNLOADED })
});

class Home extends React.Component {

  constructor(props) {
    super(props);
    this.state = {activeTab: 'sites'};
    this.changeTab = this.changeTab.bind(this);
  }

  componentWillMount() {
    const tab = this.props.token ? 'feed' : 'all';
    const tripPromise = agent.Trips.getAll;
    // this.props.onLoad(tab, Promise.all([tripPromise()]));
  }

  componentWillUnmount() {
    this.props.onUnload();
  }

  changeTab(newTab, event) {
    event.preventDefault();
    this.setState({activeTab: newTab});
  }

  render() {
    return (
      <div className="home-page">
        <div className="container page">
          <h1>Welcome {this.props.currentUser ? this.props.currentUser.fName: ''}</h1>
          <br/>

          <table className="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
                <tr>
                  <td>
                    Site
                  </td>
                  <td>
                    Create simple sites like wedding invitation sites just by entering details.
                  </td>
                  <td>
                    <Link to={'sites'} className="btn btn-secondary">See all sites</Link> 
                    &nbsp;
                    <Link to={'sites/new'} className="btn btn-warning">Create new site</Link> 
                  </td>
                </tr>
                {this.props.tables.map(table => 
                  <tr key={table.id}>
                    <td>
                      {table.label}
                    </td>
                    <td>
                      {table.description}
                    </td>
                    <td>
                      <Link to={'table/'+table.id+'/list'} className="btn btn-secondary">See all {table.id}</Link> 
                      &nbsp;
                      <Link to={'table/'+table.id+'/new'} className="btn btn-warning">Create new {table.id}</Link> 
                    </td>
                  </tr>
                  )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
